import { postAction, postJson } from "@/utils/http/service";
import { filterObj } from "@/utils/util";
import pick from "lodash.pick"

export default {
    props: {
        formPrimaryKeyField: {
            type: String,
            default: 'id'
        },
    },
    emits: ['finish'],
    data() {
        return {
            isModal: true,//是否是弹窗
            visible: false,//弹窗是否显示
            // isFinance: false, // 财务信息提交刷新
            drawerWrapClassName: 'drawer-form',

            confirmLoading: false,//确定按钮 loading
            postMethod: 'post',//请求方式 ['post','post_json']
            titlePrefix: '',//标题前缀
        }
    },
    methods: {
        /*提交表单操作*/
        onSubmit() {
            console.log("000000000000",this.submitUrl);

            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {

                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                        let action;
                        let interTrue;
                        // let isRegTest;
                        let paramsArr = [];
                        let msgTitle = '';
                        if (params.intellectualRelations && params.intellectualRelations.length != 0) {
                            paramsArr = [...params.intellectualRelations]
                            msgTitle = '知识产权信息列表中每一项都不能为空，请补充完整！'
                        } else if (params.awardList && params.awardList.length != 0) {
                            paramsArr = [...params.awardList]
                            msgTitle = '获奖信息列表中每一项都不能为空，请补充完整！'
                        } else if (params.subsidyS && params.subsidyS.length != 0) {
                            paramsArr = [...params.subsidyS]
                            msgTitle = '辅导企业信息列表中每一项都不能为空，请补充完整！'
                        } else if (params.subsidyRS && params.subsidyRS.length != 0) {
                            paramsArr = [...params.subsidyRS]
                            msgTitle = '研发机构信息列表中每一项都不能为空，请补充完整！'
                        }else if (params.subsidyKjs && params.subsidyKjs.length != 0) {
                            paramsArr = [...params.subsidyKjs]
                            msgTitle = '项目信息列表中每一项都不能为空，请补充完整！'
                        }else if (params.subsidyCrVos && params.subsidyCrVos.length != 0) {
                            paramsArr = [...params.subsidyCrVos]
                            msgTitle = '载体信息列表中每一项都不能为空，请补充完整！'
                        }else if (params.subsidyKjrs && params.subsidyKjrs.length != 0) {
                            paramsArr = [...params.subsidyKjrs]
                            msgTitle = '科小企业信息列表中每一项都不能为空，请补充完整！'
                        }else if(params.subsidySVos &&params.subsidySVos.length !=0){
                            paramsArr = [...params.subsidySVos]
                            msgTitle = '辅导的高企信息列表中每一项都不能为空，请补充完整！'
                        }
                        else if (params.correlations && params.correlations.length != 0) {
                            paramsArr = [...params.correlations]
                            msgTitle = '高企营收上台阶奖励信息列表中每一项都不能为空，请补充完整！'
                        }
                        // if(this.submitUrl === '/online/commonApi/scyq/web/enterpriseFundTracking/saveOrUpdate'){
                        //     this.obs = false
                        // }

                        if (this.obs) {
                            if (paramsArr.length != 0) {
                                paramsArr.map(item => {
                                    if (Object.values(item).includes(undefined) || Object.values(item).includes('') || Object.values(item).includes(null)) {
                                        interTrue = true
                                        this.confirmLoading = false;
                                    }
                                    // else {
                                    //     if (item.serviceEnterpriseHighNumber) {
                                    //         // let regTest = /^G[RF]2\d{3}\d{3}\d{5}$/
                                    //         let regTest = /^\S*$/
                                    //         isRegTest = regTest.test(item.serviceEnterpriseHighNumber)
                                    //         msgTitle = '辅导高企编号格式不正确！'
                                    //         this.confirmLoading = false;
                                    //     }
                                    //     if (finalRegtest&&item.patentNumber) {
                                    //         let regTest = /^\S+$/
                                    //         isRegTest = regTest.test(item.patentNumber)
                                    //         msgTitle = '专利号格式不正确！'
                                    //         this.confirmLoading = false;
                                    //         finalRegtest = !isRegTest
                                    //     }
                                    // }
                                })
                                if (interTrue) {
                                    this.$notification.warning({
                                        message: '提示',
                                        description: msgTitle,
                                    });
                                } else {
                                    if (this.submitType == 'json') {
                                        action = postJson({
                                            url: this.submitUrl,
                                            params: filterObj(this.getSubmitParams(params)),
                                            method: this.postMethod,
                                            returnMsg: true
                                        })
                                    } else {
                                        action = postAction({
                                            url: this.submitUrl,
                                            params: filterObj(this.getSubmitParams(params)),
                                            method: this.postMethod,
                                            returnMsg: true
                                        })
                                    }
                                    action.then((res) => {
                                        this.confirmLoading = false;
                                        if (this.onSuccessFn) {
                                            this.onSuccessFn(res);
                                        }
                                        if (this.isModal) {
                                            this.$emit('finish');
                                            this.onClose();
                                        }
                                        if (this.isFinance) {
                                            this.getCorpInfo()
                                        }
                                        this.$notification.success({
                                            message: '提示',
                                            description: res.msg || '操作成功',
                                        });
                                    }).catch((error) => {
                                        if(error.response.status==544){
                                            console.log('JWT报错')
                                        }
                                        console.log("222222222222222");
                                        this.confirmLoading = false;
                                    })
                                }
                            }
                        } else {
                            /*后台请求*/
                            if (this.submitType == 'json') {
                                action = postJson({
                                    url: this.submitUrl,
                                    params: filterObj(this.getSubmitParams(params)),
                                    method: this.postMethod,
                                    returnMsg: true
                                })
                            } else {
                                action = postAction({
                                    url: this.submitUrl,
                                    params: filterObj(this.getSubmitParams(params)),
                                    method: this.postMethod,
                                    returnMsg: true
                                })
                            }

                            action.then((res) => {
                                this.confirmLoading = false;

                                if (this.onSuccessFn) {
                                    this.onSuccessFn(res);
                                }

                                if (this.isModal) {
                                    this.$emit('finish');
                                    this.onClose();
                                }
                                if (this.isFinance) {
                                    this.getCorpInfo()
                                }
                                this.$notification.success({
                                    message: '提示',
                                    description: res.msg || '操作成功',
                                });
                            }).catch((error) => {
                                this.confirmLoading = false;
                                if(error.response.status==544){
                                    console.log('JWT报错')
                                }
                            })

                        }
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能为空',
                            });
                            window.console.log('error', error);
                        }
                    });
            }
        },
        /*重置表单*/
        onReset() {
            this.$refs.ruleForm.resetFields();
        },
        onClose() {
            this.visible = false;
            this.$emit("onCloseModel");
        },
        getSubmitParams(params) {
            return pick(
                Object.assign({}, params),
                Object.keys(this.rules)
            );
        }
    },
    watch: {
        visible(bool) {
            if (bool) {
                this.titlePrefix = !this.form[this.formPrimaryKeyField] ? '新增' : '修改';
            }
        }
    }
}
